import React from "react";
import "../components/styles/Legal.scss";

function PrivacyPolicy() {
  return (
    <main className="legal-page">
      <div className="legal-container">

        <h1>Privacy Policy</h1>

<p>
At KalBridge, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner.
</p>

<h3>1. Information We Collect</h3>
<p>
We may collect personal information such as your name, phone number, email address, and service requirements when you:
</p>
<ul>
  <li>Fill out enquiry or consultation forms</li>
  <li>Contact us via phone, email, or website</li>
</ul>

<h3>2. Purpose of Collection</h3>
<p>
Your information is used to:
</p>
<ul>
  <li>Provide medical verification and physiotherapy services</li>
  <li>Contact you regarding your enquiry</li>
  <li>Coordinate appointments and services</li>
</ul>

<h3>3. Data Sharing</h3>
<p>
We do not sell or share your personal information with third parties, except when required to coordinate services with authorized medical providers or as required by law.
</p>

<h3>4. Data Security</h3>
<p>
We take reasonable steps to protect your personal data from unauthorized access, misuse, or disclosure.
</p>

<h3>5. Cookies</h3>
<p>
Our website may use basic cookies to improve user experience. These do not collect sensitive personal information.
</p>

<h3>6. Your Rights</h3>
<p>
You may request access, correction, or deletion of your personal information by contacting us.
</p>

<h3>7. Contact Us</h3>
<p>
If you have any questions about this Privacy Policy, please contact us:
<br />
Email: shashi@kalbridge.com  
<br />
Phone: +91 9502451335
</p>
       
       </div>
    </main>
  );
}

export default PrivacyPolicy;